export default class DistrictAdmin {
  districtAdminId?: number | null;
  legacyProviderId?: number | null;
  lastName?: string | null;
  firstName?: string | null;
  title?: string | null;
  districtId?: number | null;
  streetAddress?: string | null;
  streetAddressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  phone?: string | null;
  fax?: string | null;
  emailAddress?: string | null;

  public constructor(params: DistrictAdmin = {} as DistrictAdmin) {
    let {
      districtAdminId = 0,
      legacyProviderId = null,
      lastName = "",
      firstName = "",
      title = null,
      districtId = 0,
      streetAddress = null,
      streetAddressLine2 = null,
      city = null,
      state = null,
      zipCode = null,
      phone = null,
      fax = null,
      emailAddress = null,
    } = params;
    this.districtAdminId = districtAdminId;
    this.legacyProviderId = legacyProviderId;
    this.lastName = lastName;
    this.firstName = firstName;
    this.title = title;
    this.districtId = districtId;
    this.streetAddress = streetAddress;
    this.streetAddressLine2 = streetAddressLine2;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.phone = phone;
    this.fax = fax;
    this.emailAddress = emailAddress;
  }
  get fullName() {
    return this.firstName + " " + this.lastName;
  }
}
